import { cn } from "@faire/react/tools/cn";
import { Dimensions } from "@faire/slate/foundation/dimensions";
import React from "react";

import { CHECKBOX_ICON_STOKE_WIDTH } from "./consts";
import { CheckboxChecked } from "./types";
import { getCheckboxIcon, getCheckboxIconClassname } from "./utils";

type IProps = {
  checked: CheckboxChecked;
};

export const CheckboxIcon: React.FC<IProps> = ({ checked }) => {
  const Icon = getCheckboxIcon(checked);
  return Icon ? (
    <div className={cn("fs-checkbox__icon", getCheckboxIconClassname(checked))}>
      <Icon
        aria-hidden
        // Do not copy this path selector unless needed, it's bad practice. It's needed
        // here because the check icon sets a 1.5px stroke width on its path, so it
        // ignores the strokeWidth prop below without it. The strokeWidth prop is here
        // because the check is shrunken down and looks too thin without it.
        className="[&_path]:[stroke-width:inherit]"
        color="currentColor"
        fontSize={Dimensions[2]}
        role="presentation"
        strokeWidth={CHECKBOX_ICON_STOKE_WIDTH}
        titleAccess={undefined}
      />
    </div>
  ) : null;
};
